// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"437e9847","496":"e387d5b7","655":"f3472d34","758":"963bbd52","787":"df52c3e4","879":"f08760c6","967":"6dbbe948","990":"4c6ce71b"}[chunkId] + ".chunk.js";
};